import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_footprint_generic_json_order_export_to_xmlService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { DatexOrderInfo?: $frontendTypes.FootprintApiManager.DatexOrderInfo }): Promise<{ DatexOrderInfoXml?: string }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

